module.exports = __webpack_public_path__ + "assets/ab4ec003e6a76fb538f2d13770cc62d7.mp3";